import { FC, useState } from "react";
import { Box, Button } from "@mui/material";
import ClosegreyBGSvg from "@/assets/svg/ClosegreyBGSvg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";

interface PostImagesProps {
  images: string[];
  onRemoveImage: (index: number) => void;
  onImageClick?: (index: number) => void;
}

const PostImages: FC<PostImagesProps> = ({ images, onRemoveImage, onImageClick }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!images.length) return null;

  if (images.length === 1 || images.length === 2) {
    return (
      <Box
        sx={{
          display: "flex",
          gap: images.length === 2 ? 1 : 0,
          marginTop: "14px",
          marginBottom: "0.875rem",
        }}
      >
        {images.map((img, idx) => (
          <Box key={idx} sx={{ position: "relative", flex: 1 }}>
            <img
              src={img}
              alt={`post_image_${idx}`}
              style={{
                borderRadius: "1rem",
                objectFit: "cover",
                width: "100%",
                height: "430px",
                cursor: onImageClick ? "pointer" : "default",
              }}
              onClick={() => onImageClick?.(idx)}
            />
            <Button
              onClick={() => onRemoveImage(idx)}
              sx={{ position: "absolute", top: 8, right: 8 }}
            >
              <ClosegreyBGSvg width={32} height={32} />
            </Button>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        marginTop: "2rem",
        marginBottom: "0.875rem",
        position: "relative",
        maxWidth: "660px",
        marginX: "auto",
      }}
    >
      <Swiper
        spaceBetween={10}
        slidesPerView={1}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        loop={true}
      >
        {images.map((img, idx) => (
          <SwiperSlide key={idx}>
            <Box sx={{ position: "relative" }}>
              <img
                src={img}
                alt={`post_image_${idx}`}
                style={{
                  borderRadius: "1rem",
                  objectFit: "cover",
                  width: "100%",
                  height: "430px",
                  cursor: onImageClick ? "pointer" : "default",
                }}
                onClick={() => onImageClick?.(idx)}
              />
              <Button
                onClick={() => onRemoveImage(idx)}
                sx={{ position: "absolute", top: 8, right: 8 }}
              >
                <ClosegreyBGSvg width={32} height={32} />
              </Button>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>

      {images.length > 1 && (
        <>
          <Button
            onClick={() => setActiveIndex((i) => (i > 0 ? i - 1 : 0))}
            sx={{ position: "absolute", top: "50%", left: 0, transform: "translateY(-50%)" }}
          >
            ◀
          </Button>
          <Button
            onClick={() => setActiveIndex((i) => (i < images.length - 1 ? i + 1 : i))}
            sx={{ position: "absolute", top: "50%", right: 0, transform: "translateY(-50%)" }}
          >
            ▶
          </Button>

          <Box sx={{ height: 4, background: "#ddd", borderRadius: 2, marginTop: 1 }}>
            <Box
              sx={{
                width: `${((activeIndex + 1) / images.length) * 100}%`,
                height: "100%",
                background: "#1976d2",
                borderRadius: 2,
                transition: "width 0.3s",
              }}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default PostImages;
